import { Container } from '@mui/material';

export default function Image({ imageSrc, imageAlrt }) {
  return (
    <Container maxWidth="lg">
      <img src={imageSrc} alt={imageAlrt} />
    </Container>
  );
}
